import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import StepProgressBar, { Step } from '../StepProgressBar';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import { useProjectContext } from '../../view/ProjectContext';

export enum AdditionalWorkflowStepId {
  VERIFY_DATA = 1,
  GROUPS = 2,
  KEY_DATES = 3,
  ALL_TASKS = 4,
  CONFLICTS = 5,
  PARTIES = 6,
}

export interface AdditionalWorkflowStepsProps {
  currentStep: AdditionalWorkflowStepId;
  disabled?: boolean;
  hasConflicts?: boolean;
  hasGroups?: boolean;
}

export default function AdditionalWorkflowSteps(props: AdditionalWorkflowStepsProps) {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const featureToggleService = useFeatureToggleService();
  const isNewFlowEnabled = featureToggleService.isApplyAdditionalWorkflowEnabled();
  const projectContext = useProjectContext();
  const deleteExistingTasks = projectContext.plan?.deleteExistingTasks ?? false;

  const steps: Step[] = [];

  if (navigator.isAiFlow) {
    steps.push({
      id: AdditionalWorkflowStepId.VERIFY_DATA,
      name: 'Verify Data',
      onClick: () => navigator.openVerifyDataPage(),
      disabled: props.disabled,
    });
  }

  if (props.hasGroups) {
    steps.push({
      id: AdditionalWorkflowStepId.GROUPS,
      name: 'Select Groups',
      onClick: () => navigator.openGroupsPage(),
      disabled: props.disabled,
    });
  }

  steps.push(
    {
      id: AdditionalWorkflowStepId.KEY_DATES,
      name: 'Edit Key Dates',
      onClick: () => navigator.openKeyDateTasksPage(),
      disabled: props.disabled,
    },
    {
      id: AdditionalWorkflowStepId.ALL_TASKS,
      name: 'Edit All Tasks',
      onClick: () => navigator.openAllTasksPage(),
      disabled: props.disabled,
    },
  );

  if (isNewFlowEnabled && props.hasConflicts && !deleteExistingTasks) {
    steps.push({
      id: AdditionalWorkflowStepId.CONFLICTS,
      name: 'Resolve Conflicts',
      onClick: () => navigator.openConflictsPage(),
      disabled: props.disabled,
    });
  }

  steps.push({
    id: AdditionalWorkflowStepId.PARTIES,
    name: navigator.isAiFlow ? 'Transaction Parties' : 'Add Transaction Parties',
    onClick: () => navigator.openPartiesPage(),
    disabled: props.disabled,
  });

  return (
    <StepProgressBar steps={steps} currentStep={props.currentStep} withTitles />
  );
}
